'use client';
// libs
import { createContext } from 'react';
import { Context } from './account.context.interface';

export const context = createContext<Context>({
  account: null,
  isAccountLoading: false,
});
